import type {
  BundledPackageStateToLodgingId,
  BundledPackageStateToRateId,
} from "@b2bportal/core-packages";
import { type ExternalResource, CallState } from "@b2bportal/core-types";
import type { ThunkErrorType } from "@b2bportal/core-utilities";
import type {
  ShopResponseAvailable,
  LodgingTravelWalletOffer,
} from "@b2bportal/lodging-api";
import type { PackageRoom } from "@b2bportal/packages-api";
import type { PackageSearchQueryParams } from "@tenant/types";

/**
 * Packages grouped by lodging ID
 */
export type TPackagesByLodgingId = {
  packagesByLodgingId: BundledPackageStateToLodgingId;
  searchId: string;
  dateRange?: {
    from: string;
    until: string;
  };
};

/**
 * Packages grouped by rate ID
 */
export type TPackagesByRateId = {
  packagesByRateId: { [key: string]: PackageRoom };
};

/**
 * Response type for fetchPackageHotelShop thunk
 */
export type FetchPackageHotelShopFulfillResponse = {
  shop: ShopResponseAvailable;
  bestOffer?: LodgingTravelWalletOffer;
  search: PackageSearchQueryParams;
  availabilityTrackingProperties?: Record<string, any>;
  packageStateByRateId: BundledPackageStateToRateId;
};

/**
 * State shape for package hotel availability
 */
export type PackageHotelAvailabilityState = {
  availability: ExternalResource<
    TPackagesByLodgingId,
    ThunkErrorType<{ error: string }>
  >;

  shop: ExternalResource<
    FetchPackageHotelShopFulfillResponse,
    ThunkErrorType<{ error: string }>
  >;
};

/**
 * Overall package hotel state
 */
export type PackageHotelState = PackageHotelAvailabilityState;

/**
 * Initial state for package hotels
 */
export const initialHotelState: PackageHotelState = {
  availability: { state: CallState.NotCalled },
  shop: { state: CallState.NotCalled },
};
